import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { useMemo } from 'react';
import { useTheme, Chip } from '@mui/material';
import { ReactComponent as SvgZscoreIcon } from '../../../assets/icons/zscore-icon.svg.js';

var ZScore = function (_a) {
    var value = _a.value, _b = _a.mini, mini = _b === void 0 ? false : _b, sxProp = _a.sx, rest = __rest(_a, ["value", "mini", "sx"]);
    var theme = useTheme();
    var sx = useMemo(function () { return ({
        "&": {
            gap: "6px",
            padding: "0 ".concat(mini ? 12 : 16, "px"),
            borderRadius: "18px",
            backgroundImage: "linear-gradient(to top, #3e3177, #263e6f)",
            height: "".concat(mini ? 28 : 36, "px"),
        },
        "&&> *": {
            margin: 0,
            padding: 0,
        },
        "& .MuiChip-label": {
            fontSize: "".concat(16, "px"),
            fontWeight: 600,
            color: theme.palette.neutral000,
        },
    }); }, [mini, theme]);
    return (React__default.createElement(Chip, __assign({ sx: __assign(__assign({}, sx), sxProp), icon: mini ? undefined : React__default.createElement(SvgZscoreIcon, null), label: Math.round(value) }, rest)));
};

export { ZScore as default };
